<template>
  <div>
    <v-progress-linear
      :active='progBar'
      indeterminate
      absolute
      top
      color="blue"
      height="5"
    />
    <v-alert
      prominent
      :value="alert"
      :color="alertColor"
      dark
      icon="mdi-home"
      transition="scale-transition"
      class="ma-1"
    >
      <v-row align="center">
        <v-col class="grow subtitle-1">{{ alertMsg }}</v-col>
        <v-col class="shrink">
          <v-btn color="white black--text" @click="tutupClick">Tutup</v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
export default {
  computed: {
    progBar: function() {
      return this.$store.state.progressBar
    },
    alert: function() {
      return this.$store.state.alertBox
    },
    alertMsg: function() { 
      return this.$store.state.alertMessage
    },
    alertColor: function() {
      return this.$store.state.alertColor   
    }
  },
  methods: {
    tutupClick: function() {
      this.$store.dispatch('closeAlert')
    }
  }
}
</script>

<style>

</style>